const POWERS = {
  master: 'master',
  talent: 'talent', // basic permission needed to work with rome.

  settings: 'settings',

  // contracts
  contracts: 'contracts',
  createContract: 'create-contract',
  updateContract: 'update-contract',
  terminateContract: 'terminate-contract',

  // This is the permision to provide salary raise
  updateDeal: 'update-deal',

  customerSOWs: 'customer-sows',

  // TODO: Pending
  createSubmission: 'create-submission',

  contactsAndCompanies: 'contacts-and-companies',

  userAccounts: 'user-accounts',
} as const

export default POWERS
